// extracted by mini-css-extract-plugin
module.exports = {"containerSend":"Send_containerSend__3ORQV","image":"Send_image__21Zdy","titleSend":"Send_titleSend__kJDPB","buttonInfo":"Send_buttonInfo__2HCGe"};